export const SET_ONLINE_PING_STATUS = 'SET_ONLINE_PING_STATUS'

export const setOnlinePingStatus = onlinePingStatus => ({
  type: SET_ONLINE_PING_STATUS,
  payload: onlinePingStatus,
})
